import { DriverWaybillBidModel } from "api";
import { sortedPoints } from "helpers/bidpoint";
import { syncEntityTypesEnum } from "helpers/enums";
import { alertRequest, body, request } from "services/request";
import { getLastSyncStatus } from "sources/syncStatuses";

const resource = "api/bids";

export const getBid = (id: number) =>
    Promise.all([bidReq(id), getLastSyncStatus(syncEntityTypesEnum.Bid, id)]).then(([bid, syncStatusData]) =>
        bid ? { ...bid, syncStatusData } : false,
    );

export const getBidMainData = (id: string) =>
    request(`${resource}/get/${id}?mainDataOnly=true`, { method: "GET" }).then((res) => {
        if (res) {
            res.bidPoints = sortedPoints(res.bidPoints);
        }
        return res;
    });

const bidReq = (id: number) =>
    request(`${resource}/get/${id}`, { method: "GET" }).then((data) => {
        if (data?.waybills?.length > 0) {
            data.waybills.forEach((waybill: DriverWaybillBidModel) => {
                (waybill.titles || []).sort((a, b) => Number(a.type[1]) - Number(b.type[1]));
            });
        }
        return data;
    });

export const getBidContact = (params: { phoneNumber: string }) =>
    request(`${resource}/getContact?phoneNumber=${encodeURIComponent(params.phoneNumber)}`, { method: "GET" });

export const deleteBid = (params: {}) => alertRequest(`${resource}/delete`, body(params));

export const cancelBid = (params: {}) => alertRequest(`${resource}/cancel`, body(params));

export const restoreBid = (params: {}) => alertRequest(`${resource}/restore`, body(params));
